import { AssistentItem } from '../assistent_config';
import { DataService } from '../../../../services/data_service';
import { getWetterstation } from '../../functions/getWetterstation';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WFormData } from '../../../../core/forms/WFormData';

let lastAdressString: string;

export function getAssistentConfigVeranstaltungen(data: any, dataService: DataService, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    const config: any = require('../../../../wips.config.js');
    const devFeatures: boolean = config.devFeatures || false;
    const konfiguration: Array<any> = data[IDs.ENT_KONFIGURATION] || [];
    const eingabe_veranstaltungen: AssistentItem = {
        gliederung: '1.4',
        name: 'Veranstaltungen',
        description: 'Dies ist das Formular zur Eingabe der Veranstaltungs-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_STANDORT,
        module: IDs.MOD_ETOOL,
        style: { marginLeft: '18px' },
        // disablePruefer: true,
        singleItem: false,
        configFlag: 'checkVeranstaltungen',
        addLabel: 'Neue Veranstaltung',
        vorhandenName: 'Veranstaltungen',
        customFilter: (item: any) => item.standort_typ_tid_orig === 6 || item.standort_typ_tid_orig === 5,
        // customAllowContinue: (dataItem: any) => {
        //     return (!Object.keys(dataItem || {}).length
        //         || !!(dataItem && (dataItem.energiedaten_erfassen_orig && +dataItem.energiedaten_erfassen_orig > 0 ||
        //             dataItem && dataItem.energiedaten_erfassen && +dataItem.energiedaten_erfassen > 0)
        //         )
        //     );
        // },
        // blockText: 'Bitte wählen Sie, ob Energiedaten erfasst werden sollen!',
        onFormChangeInteractive: async (formData: WFormData, onValueChange: (name: string, value: any) => void) => {
            if (!formData.getValue('standort_typ_tid')) {
                onValueChange('standort_typ_tid', 5);
            }
            lastAdressString = await getWetterstation(data, lastAdressString, formData, onValueChange);
        },
        bundleFilterFunc: (bundle: any, dat: any) => {
            bundle.standort_typ_tid = bundle.standort_typ_tid.filter((item: any) => item.tid === 5 || item.tid === 6);
            bundle.standort_tid = bundle.standort_tid.filter((item: any) => !(item.standort_typ_tid_orig === 5 || item.standort_typ_tid_orig === 6));
        },
        disableFieldSelectDefaultOptions: {
            energiedaten_erfassen: true
        },
        customFormConfig: {
            gruppe: { hidden: true }
        },
        ...(customCfg || {})
    };
    return eingabe_veranstaltungen;
}

